import { Component, inject, PLATFORM_ID } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MdbCollapseModule } from 'mdb-angular-ui-kit/collapse';
import { NgOptimizedImage, ViewportScroller, isPlatformBrowser } from '@angular/common';
import { IconComponent } from './icon/icon.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [
        RouterModule,
        MdbCollapseModule,
        IconComponent,
        NgOptimizedImage
    ]
})
export class AppComponent {
    year: number;
    private platformId = inject(PLATFORM_ID);

    constructor() {
        const viewportScroller = inject(ViewportScroller);

        this.year = new Date().getFullYear();
        if (isPlatformBrowser(this.platformId)) {
            viewportScroller.setOffset([0, 80]);
        }
    }
}
